import {
  FETCH_ALL_RETIRED_BULLETIN_BEGIN,
  FETCH_ALL_RETIRED_BULLETIN_SUCCESS,
  FETCH_ALL_RETIRED_BULLETIN_FAILURE,
  FETCH_ALL_RETIRED_BULLETIN_RESET_DEFAULT_FILTER,
  FETCH_ALL_RETIRED_BULLETIN_SET_FILTER,
  FETCH_SINGLE_RETIRED_BULLETIN_BEGIN,
  FETCH_SINGLE_RETIRED_BULLETIN_SUCCESS,
  FETCH_SINGLE_RETIRED_BULLETIN_FAILURE
} from "redux/action/actionTypes";
import { TableFilters } from "component/Base/Helper";

const initialState = {
  data: [],
  singleBullData: {},
  filter: TableFilters.defaultRetireBulletinFilter,
  loading: false,
  error: null
};

export default function retiredBulletinReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALL_RETIRED_BULLETIN_BEGIN:
      return {
        ...state,
        filter: action.filter,
        loading: true,
        shouldRefreshData: action.shouldRefreshData
      };

    case FETCH_ALL_RETIRED_BULLETIN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        total: action.total
      };

    case FETCH_ALL_RETIRED_BULLETIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case FETCH_ALL_RETIRED_BULLETIN_RESET_DEFAULT_FILTER:
      return {
        ...state,
        loading: false,
        data: [],
        filter: action.filter,
        shouldRefreshData: action.shouldRefreshData
      };

    case FETCH_ALL_RETIRED_BULLETIN_SET_FILTER:
      return {
        ...state,
        loading: false,
        data: [],
        filter: action.filter
      };

    case FETCH_SINGLE_RETIRED_BULLETIN_BEGIN:
      return {
        ...state,
        singleBullPending: action.loading
      };

    case FETCH_SINGLE_RETIRED_BULLETIN_SUCCESS:
      return {
        ...state,
        singleBullData: action.singleBullData,
        singleBullPending: action.loading
      };

    case FETCH_SINGLE_RETIRED_BULLETIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}
